/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component, OnInit, Input, Output, ViewChild, EventEmitter, SimpleChanges } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CommonService } from '../../shared/services/common.service';
import {
  VolumeTransferConfirmationModalComponent
} from './volume-transfer-confirmation-modal.component';
import { PlanPeriodsService } from '../services/planperiods.service';
import { OrderService } from '../services/order.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MoveOrderService } from '../move-order/move-order.service';
import { VolumeTransferService } from 'app/components/application/globalPlanElements/volumeTransfer/volumeTransfer.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-volume-transfer',
  templateUrl: './volume-transfer.component.html',
  styleUrls: ['./volume-transfer.component.scss'],
  providers: [PlanPeriodsService, OrderService, VolumeTransferService]
})
export class VolumeTransferComponent implements OnInit {
  @ViewChild('volumeTransferForm') volumeTransferForm!: NgForm;
  @Output() closeSlider: EventEmitter<any> = new EventEmitter();
  @Input() defaultParticipant: any;
  public notificationOptions = {
    timeOut: 4000,
    showProgressBar: true,
    pauseOnHover: true,
    clickToClose: true,
    maxLength: 0,
    position: ['right', 'top']
  };
  public selectedFromDistributor: any;
  public fromDistributorNotSelected = true;
  public selectedToDistributor: any;
  public toDistributorNotSelected = true;
  public transferDescription = 'There will be a 15% ($5) Transfer Fee for this PV Transfer.';
  public hasMinVolReqError = false;
  public hasSamePayeePayerError = false;
  public currentPeriod: any;
  public currentYear!: string;
  public isFormSubmittedSuccessfully = false;
  public orderedBy = 'phone';
  public transferFeeForPVTransfersType = 'acceptAndContinue';
  public pvtTransactionId = '';
  public pvtFeeTransactionId = '';
  public hasAccess = true;
  public periodName: any = '';
  public defaultSearchText: any;
  public defaultToSearchText: any;
  public periods: any = [];
  public getPreviousPeriodsAPILoaded = false;
  public translationsObj: any = {};
  public vol: any = {};
  public curPeriodIndex: any;
  public defaultParticipantInfo: any;
  public menuObj: any = {};
  public transferTypes: any = [];
  public volumeTransferType: any = {};
  public hasAdminOverrideAccess: any = false;
  public adminOverride: any = false;
  public originalOrderId: any;
  public globalVolTransferData: any;
  public eligibleVolumes: any = [];
  public volumes: any = [];
  public currentPeriodRef: any = '';
  public volGQV: any = {
    payer: 0,
    payee: 0
  };
  public reverseVol: any = false;
  public orderPeriodName: any = '';
  private defaultConfig: ModalOptions = {
    backdrop: true,
    ignoreBackdropClick: true
  };

  constructor(private modalService: BsModalService,
    public commonService: CommonService,
    private planPeriodsService: PlanPeriodsService,
    private VolumeTransferService: VolumeTransferService,
    private translate: TranslateService,
    private orderService: OrderService,
    private moveOrderService: MoveOrderService,
    private router: Router) {
    const menuId = this.commonService.getMenuId('TRF');
    this.vol.moveToPeriod = {};
      this.commonService.setHelpObj({
        header: this.getTranslationWithKey('TRF') || '',
        menuId: menuId,
        sections: [],
        lastSavedData: [],
        relatedLinks: [
          {
            label: this.getTranslationWithKey('FLP'),
            url: '/fieldsupport/distributorList/default'
          }, {
            label: this.getTranslationWithKey('GLY'),
            url: '/genealogyHome/genealogy/default'
          }
        ]
      });
  }

  ngOnInit() {
    const vm = this;

    this.hasAccess = this.commonService.hasFeatureAccess('Volume Transfer');
    this.hasAdminOverrideAccess = this.commonService.hasFeatureAccess('Volume Transfer Admin Override');
    this.getGlobalVolTransferData();
    this.getCurrentPeriod();
    this.getTransferTypes();
  }

  private getCurrentPeriod() {
    // Company Code Fix
    const companyCode = this.commonService.getCompanyCode();
    this.moveOrderService.getCurrentPeriod(companyCode)
      .then(this.currentPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  public getTranslationWithKey(key: string): string {
    return this.commonService.getTranslatedVal(key);
  }

  private currentPeriodDetailsSH(response: any) {
    const responseMsg = response, user = '';
    if (responseMsg) {
      this.currentPeriodRef = responseMsg.name;
      this.getPreviousPeriods('');
    }
  }

  private getCurrentPeriodSH(response: any) {
    const period = response;
    if (this.commonService.getReprocess()) {
      this.currentPeriod = period.precedes;
    } else {
      this.currentPeriod = period.currentPeriod;
    }

    this.currentYear = this.currentPeriod.name.substr(0, 4);
    if (!this.commonService.getReprocess()) {
      if (this.orderPeriodName) {
        this.periodName = this.orderPeriodName;
        this.vol.moveToPeriod.name = JSON.parse(JSON.stringify(this.orderPeriodName));
      } else {
        this.periodName = this.currentPeriod.name;
        this.vol.moveToPeriod = JSON.parse(JSON.stringify(this.currentPeriod));
      }
    } else {
      /* Removing current period from "Move To Period" list */

      this.periods.splice(this.curPeriodIndex, 1);
      // this.commonService.setReprocess(false);
      this.periodName = this.periods[0].name;

      setTimeout(() => {
        /* Last Previous Period */
        this.vol.moveToPeriod = this.periods[0];
        if (this.commonService.getReprocess()) {
          this.moveOrderService.getCommissionVolumes(this.selectedFromDistributor?.clientId, this.vol.moveToPeriod.name, false)
            .then(this.getCommissionVolumesSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
          if (this.selectedToDistributor) {
            this.moveOrderService.getCommissionVolumes(this.selectedToDistributor?.clientId, this.vol.moveToPeriod.name, false)
              .then(this.getCommissionToVolumesSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
          }
        }
      }, 100);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const vm = this;

    if (changes['defaultParticipant'] && changes['defaultParticipant'].currentValue) {
      if (changes['defaultParticipant'].currentValue.payer) {
        if (changes['defaultParticipant'].currentValue.reverse) {
          this.reverseVol = changes['defaultParticipant'].currentValue.reverse;
          if (changes['defaultParticipant'].currentValue.periodName) {
            this.orderPeriodName = changes['defaultParticipant'].currentValue.periodName;
            this.vol.moveToPeriod.name = changes['defaultParticipant'].currentValue.periodName;
          }
        }
        this.volumeTransferType = changes['defaultParticipant'].currentValue.volumeTransferType;
        this.defaultSearchText = changes['defaultParticipant'].currentValue.payee?.clientId;
        this.fromDistributorSelected(changes['defaultParticipant'].currentValue.payee);
        this.defaultToSearchText = changes['defaultParticipant'].currentValue.payer?.clientId;
        this.toDistributorSelected(changes['defaultParticipant'].currentValue.payer);
        this.volumes = changes['defaultParticipant'].currentValue.volumes;
        changes['defaultParticipant'].currentValue.volumes.forEach((vol: any) => {
          this.checkEligibleVolumes(vm.eligibleVolumes, vol);
        })
        this.originalOrderId = changes['defaultParticipant'].currentValue.orderId;
        this.volCalcDetails();
      } else {
        this.defaultSearchText = changes['defaultParticipant'].currentValue?.clientId;
        this.fromDistributorSelected(changes['defaultParticipant'].currentValue);
      }
    }
  }

  public close() {
    this.closeSlider.emit();
  }

  private getGlobalVolTransferData() {
    this.VolumeTransferService.getAllVolumeTransferDetails()
      .then(this.getAllVolumeTransferDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getAllVolumeTransferDetailsSH(res: any) {
    const vm = this;
    this.globalVolTransferData = res;
    if (this.volumeTransferType && this.globalVolTransferData) {
      this.globalVolTransferData.forEach(function (volTrans: any) {
        if (volTrans.volumeTransferType.id == vm.volumeTransferType.id) {
          vm.eligibleVolumes = volTrans.eligibleVolumes;
        }
      })
    }
    this.volumes.forEach((vol: any) => {
      this.checkEligibleVolumes(vm.eligibleVolumes, vol);      
    });
  }

  private checkEligibleVolumes(eligibleVolumes: any, vol: any) {
    eligibleVolumes.forEach((elgVol: any) => {
      if (elgVol.code == vol.code) {
        elgVol.ipVal = vol.value
      }
    })
  }

  public toDistributorSelected(event: any) {
    // reset filters
    this.clearToDistFilter();
    this.toDistributorNotSelected = false;
    this.selectedToDistributor = event;

    if (!this.selectedToDistributor.name) {
      this.selectedToDistributor.name = (this.selectedToDistributor.firstName || '') + ' ' + (this.selectedToDistributor.lastName || '');
    }


    if (this.selectedToDistributor && this.commonService.getReprocess() && this.vol && this.vol.moveToPeriod) {
      this.moveOrderService.getCommissionVolumes(this.selectedToDistributor?.clientId, this.vol.moveToPeriod.name, false)
        .then(this.getCommissionToVolumesSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }

    if (this.selectedFromDistributor && this.selectedToDistributor && this.selectedToDistributor.position) {
      this.selectedToDistributor.position.directVolumes.PPV = this.selectedToDistributor.position.directVolumes.PPV || 0;
      this.selectedToDistributor.position.directVolumes.PQV = this.selectedToDistributor.position.directVolumes.PQV || 0;
      this.selectedToDistributor.position.sponsorVolumes.OV = this.selectedToDistributor.position.sponsorVolumes.OV || 0;
    } else {
      this.selectedToDistributor.position = {
        directVolumes: {
          PPV: 0,
          PQV: 0
        },
        sponsorVolumes: {
          OV: 0
        }
      };
    }

    if (this.selectedFromDistributor?.clientId == this.selectedToDistributor?.clientId) {
      this.hasSamePayeePayerError = true;
    }

    // if (this.fromDistributorSelected && this.toDistributorSelected) {
      this.eligibleVolumes.forEach(function (elgVol: any) {
        if (!elgVol.ipVal) {
          elgVol.ipVal = 0;
        }
      })
      this.volCalcDetails();
    // }
  }

  public getTransferTypes() {
    this.VolumeTransferService.getVolumeTransferMetaData()
      .then(this.volumeTransferMetaDataSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  public volumeTransferMetaDataSH(response: any) {
    const res = response;
    if (res) {
      this.transferTypes = res.volumeTransferType || [];
    }
  }

  public updateTransferType() {
    const transID = this.volumeTransferType.id, vm = this;
    this.globalVolTransferData.forEach(function (volTrans: any) {
      if (volTrans.volumeTransferType.id == transID) {
        vm.eligibleVolumes = volTrans.eligibleVolumes;
      }
    })
  }

  public getSubmitValid(selectedFromDistributor: any) {
    let isValid = false;
    for (const elgVol of this.eligibleVolumes) {
      if (elgVol.ipVal > 0) {
        isValid = true;
        break;
      } else {
        isValid = false;
      }
    }
    if (!isValid) {
      return isValid;
    }

    for (const elgVol of this.eligibleVolumes) {
      if ((elgVol.prCalVol - elgVol.ipVal) > -1) {
        isValid = true;
      } else {
        isValid = false;
        break;
      }
    }
    return isValid;
  }

  public clearToDistFilter() {
    if (!this.reverseVol) {
      this.toDistributorNotSelected = true;
      this.selectedToDistributor = null;
      this.hasSamePayeePayerError = false;
    }
  }

  public fromDistributorSelected(event: any) {
    // reset filters
    this.clearFromDistFilter();
    this.fromDistributorNotSelected = false;
    this.selectedFromDistributor = event;

    if (!this.selectedFromDistributor.name) {
      this.selectedFromDistributor.name = (this.selectedFromDistributor.firstName || '') + ' ' + (this.selectedFromDistributor.lastName || '');
    }

    if (this.selectedFromDistributor && this.commonService.getReprocess() && this.vol && this.vol.moveToPeriod) {
      this.moveOrderService.getCommissionVolumes(this.selectedFromDistributor?.clientId, this.vol.moveToPeriod.name, false)
        .then(this.getCommissionVolumesSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }

    if (this.selectedFromDistributor && this.selectedFromDistributor.position) {
      const ppvCount =
        this.selectedFromDistributor.position.directVolumes.PPV = this.selectedFromDistributor.position.directVolumes.PPV || 0;

      const pqvCount =
        this.selectedFromDistributor.position.directVolumes.PQV = this.selectedFromDistributor.position.directVolumes.PQV || 0;

      this.selectedFromDistributor.position.sponsorVolumes.OV = this.selectedFromDistributor.position.sponsorVolumes.OV || 0;

      if (ppvCount < 0 || pqvCount < 0) {
        this.hasMinVolReqError = true;
      } else {
        this.hasMinVolReqError = false;
      }
    } else {
      this.selectedFromDistributor.position = {
        directVolumes: {
          PPV: 0,
          PQV: 0
        },
        sponsorVolumes: {
          OV: 0
        }
      };
    }
    setTimeout(() => {
      if (this.currentPeriod) {
        this.vol.moveToPeriod = JSON.parse(JSON.stringify(this.currentPeriod));
      }
    }, 0);
  }

  private getCommissionVolumesSH(res: any) {
    this.selectedFromDistributor.position = res.position;
  }

  private getCommissionToVolumesSH(res: any) {
    this.selectedToDistributor.position = res.position;
  }

  public clearFromDistFilter() {
    if (!this.reverseVol) {
      this.fromDistributorNotSelected = true;
      this.selectedFromDistributor = null;
      this.hasMinVolReqError = false;
      this.hasSamePayeePayerError = false;
    }
  }

  public onVolumeChange(elg: any) {
    let val: any, vm = this, trnsName = '';
    this.eligibleVolumes.forEach(function (vol: any) {
      if (elg.code == vol.code) {
        val = vol.ipVal;
      }
    })
    this.eligibleVolumes.forEach(function (vol: any) {
      vol.ipVal = val;
    });

    this.transferTypes.forEach(function (trnsType: any) {
      if (trnsType.id == vm.volumeTransferType.id) {
        trnsName = trnsType.name;
      }
    })
    this.volCalcDetails();
  }

  private volCalcDetails() {
    setTimeout(() => {
      const payload: any = {};
      payload.calcualteVolume = 'GQV';
      payload.payer = {};
      payload.payer.clientId = this.selectedFromDistributor?.clientId;
      payload.payee = {};
      payload.payee.clientId = this.selectedToDistributor?.clientId;
      payload.volumePeriod = this.vol.moveToPeriod.name;
      payload.volumeTransferType = {};
      payload.volumeTransferType.id = this.volumeTransferType.id
      payload.volumes = [];
      this.eligibleVolumes.forEach(function (elgVol: any) {
        const volObj: any = {};
        volObj.code = elgVol.code;
        volObj.value = elgVol.ipVal;
        payload.volumes.push(volObj);
      })
      this.VolumeTransferService.getVolumeCalculation(payload)
        .then(this.getVolumeCalculationSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }, 1000);
  }

  private getVolumeCalculationSH(res: any) {
    if (res.payer.position && res.payer.position.groupVolumes) {
      this.volGQV.payer = res.payer.position.groupVolumes.GQV;
      this.volGQV.payee = res.payee.position.groupVolumes.GQV;
    }
    this.eligibleVolumes.forEach(function (elgVol: any) {
      if (res.payer.position && res.payer.position.directVolumes) {
        elgVol.prCalVol = res.payer.position.directVolumes[elgVol.code];
        elgVol.peCalVol = res.payee.position.directVolumes[elgVol.code];
      }
    })
  }

  public onShowConfirmationPopUp() {
    const vm = this, obj: any = {
      fromName: this.selectedFromDistributor.name,
      toName: this.selectedToDistributor.name,
      fromClientId: this.selectedFromDistributor?.clientId,
      toClientId: this.selectedToDistributor?.clientId,
      ppvVolumeTransferCount: vm.eligibleVolumes[0].ipVal,
      pqvVolumeTransferCount: vm.eligibleVolumes[0].ipVal,
      volumeTransferType: this.volumeTransferType,
      eligibleVolumes: this.eligibleVolumes
    };
    if (this.hasAdminOverrideAccess) {
      obj.adminOverride = this.adminOverride;
    }
    const initialState = {
      context:{ data: obj, dialogClass: 'modal-dialog vt-confirmation-modal' } // Pass the data object directly
    };
    
    const modalRef: BsModalRef = this.modalService.show(VolumeTransferConfirmationModalComponent, {
      ...this.defaultConfig,
      initialState,
      class: 'modal-dialog modal-custom-width'
    });
    
    // Handle modal close event
    modalRef.content?.closeModal.subscribe((result: any) => {
      if (result) {
        this.saveVolTransfer(result);
      }
    });
  }

  private saveVolTransfer(result: any) {
    if (result === 'confirmed') {
      this.onVolTransferSubmit();
    }
  }

  private onVolTransferSubmit() {
    const reqPayload: any = {
      type: 'VolumeTransfer',
      source: 'API',
      volumeTransfer: {
        'orderId': new Date().getTime().toString(),
        'orderType': 'VolumeTransfer',
        'source': this.orderedBy,
        // 'transferFeeForPVTransfersType': this.transferFeeForPVTransfersType,
        'orderDate': (new Date()).toISOString(),
        'payer': {
          'clientId': this.selectedFromDistributor?.clientId
        },
        'payee': {
          'clientId': this.selectedToDistributor?.clientId
        },
        volumePeriod: this.vol.moveToPeriod.name,
        'volumes': [],
        "volumeTransferType": this.volumeTransferType
      },
    };
    if (this.originalOrderId) {
      reqPayload.volumeTransfer.originalVolumeTransferId = this.originalOrderId;
      reqPayload.volumeTransfer.reversal = true;
    }
    if (this.hasAdminOverrideAccess) {
      reqPayload.volumeTransfer.adminOverride = this.adminOverride;
    }

    if (this.selectedFromDistributor.leader) {
      reqPayload.volumeTransfer['payerLeader'] = { 'clientId': this.selectedFromDistributor.leader?.clientId };
    }

    if (this.selectedToDistributor.leader) {
      reqPayload.volumeTransfer['payeeLeader'] = { 'clientId': this.selectedToDistributor.leader?.clientId };
    }

    this.eligibleVolumes.forEach(function (elgVol: any) {
      reqPayload.volumeTransfer.volumes.push({
        code: elgVol.code,
        value: (elgVol.ipVal) ? elgVol.ipVal : 0
      });
    })



    // if (this.isPQVTransferChecked) {
    //   reqPayload.volumeTransfer.volumes.push({
    //     code: 'PQV',
    //     value: this.pqvVolumeTransferCount
    //   });
    // }
    this.orderService.createOrder(reqPayload).then(this.createOrderSH.bind(this), this.createOrderFH.bind(this));
  }

  private createOrderSH(response: any) {
    const orderId = response.orderId;
    this.pvtTransactionId = orderId;
    this.isFormSubmittedSuccessfully = true;
    // this.submitTransferFee(orderId);
  }

  private createOrderFH(error: any) {
    this.isFormSubmittedSuccessfully = false;
    this.commonService.commonErrorHandler(error);
  }

  public onStartNewTransfer() {
    this.isFormSubmittedSuccessfully = false;
    this.selectedFromDistributor = null;
    this.selectedToDistributor = null;
    this.hasMinVolReqError = false;
    this.hasSamePayeePayerError = false;
    this.pvtTransactionId = '';
    this.pvtFeeTransactionId = '';
    this.orderedBy = 'phone';
  }

  private submitTransferFee(orderId: any) {
    const reqPayload: any = {
      type: 'Order',
      source: 'API',
      order: {
        orderId: new Date().getTime().toString(),
        orderType: 'Order',
        volumeRecipient: {
          clientId: this.selectedFromDistributor?.clientId
        },
        purchasedBy: {
          clientId: this.selectedFromDistributor?.clientId
        },
        source: 'Fees',
        originalOrderId: orderId,
        'orderDate': (new Date()).toISOString(),
        volumePeriod: this.vol.moveToPeriod.name,
        description: 'Volume Transfer Fee',
        orderTotal: 0,
        totalPaid: 0,
        totalSpecial: 0,
        totalProfit: 0,
        totalTax: 0
      }
    };

    if (this.selectedFromDistributor.leader) {
      reqPayload.order['businessLeader'] = { 'clientId': this.selectedFromDistributor.leader?.clientId };
    }

    this.orderService.createOrder(reqPayload).then(this.transferFeeSH.bind(this), this.transferFeeFH.bind(this));
  }

  private transferFeeSH(response: any) {
    this.pvtFeeTransactionId = response;
    this.isFormSubmittedSuccessfully = true;
  }

  private transferFeeFH(error: any) {
    this.isFormSubmittedSuccessfully = false;
    this.commonService.commonErrorHandler(error);
  }

  private getPreviousPeriods(defaultParticipant: any) {
    if (!this.getPreviousPeriodsAPILoaded) { /*Restrict to call API only once */
      this.moveOrderService.getPreviousPeriods({ hideLoader: true })
        .then(this.getPreviousPeriodsSH.bind(this, defaultParticipant), (reason) => this.commonService.commonErrorHandler(reason));
    }
  }

  private getPreviousPeriodsSH(defaultParticipant: any, response: any) {
    this.getPreviousPeriodsAPILoaded = true; this.curPeriodIndex = '';
    let year, vm = this;
    this.periods = response || [];
    this.periods.forEach((element: any, index: any) => {
      if (!element) return;
      year = (element.name) ? element.name.substring(0, 4) : '';
      element.periodDefinition = element.periodDefinition || {};
      if (element.name == vm.currentPeriodRef) {
        //if (element.current) {
        element.label = (element.periodDefinition.name || '') + ' ' + year + ' (' + this.getTranslationWithKey('current_period') + ')';
        element.currentPeriodName = (element.periodDefinition.name || '') + ' ' + year;
        this.currentPeriod = element;
        this.curPeriodIndex = index;
      } else {
        element.label = (element.periodDefinition.name || '') + ' ' + year + ' (' + this.getTranslationWithKey('future_period') + ')';
        element.prevPeriodName = (element.periodDefinition.name || '') + ' ' + year;
      }
    });
    if (this.hasAccess) {
      this.planPeriodsService.getPeriod({ hideLoader: true })
        .then(this.getCurrentPeriodSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    }

  }

  public onVolumePeriodChange(periodName: any) {
    const clientId = this.selectedFromDistributor?.clientId;
    this.VolumeTransferService.getPeriodDetails(clientId, periodName)
      .then(this.getPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
    this.VolumeTransferService.getPeriodDetails(this.selectedToDistributor?.clientId, periodName)
      .then(this.getToPeriodDetailsSH.bind(this), (reason) => this.commonService.commonErrorHandler(reason));
  }

  private getToPeriodDetailsSH(res: any) {
    this.selectedToDistributor = res;
    if (!this.selectedToDistributor.name) {
      this.selectedToDistributor.name = (this.selectedToDistributor.firstName || '') + ' ' + (this.selectedToDistributor.lastName || '');
    }
  }

  private getPeriodDetailsSH(res: any) {
    this.selectedFromDistributor = res;
    if (!this.selectedFromDistributor.name) {
      this.selectedFromDistributor.name = (this.selectedFromDistributor.firstName || '') + ' ' + (this.selectedFromDistributor.lastName || '');
    }
    this.volCalcDetails();
  }
}
